import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8dedc5c185aba8d/components/sections/CtaSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FAQSection"] */ "/tmp/8dedc5c185aba8d/components/sections/FAQSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SolutionsGrid"] */ "/tmp/8dedc5c185aba8d/components/sections/SolutionsGrid.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dedc5c185aba8d/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedc5c185aba8d/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedc5c185aba8d/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedc5c185aba8d/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedc5c185aba8d/components/sections/KeyTakeawaysSection.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedc5c185aba8d/app/[locale]/integrations/[slug]/integration.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedc5c185aba8d/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8dedc5c185aba8d/node_modules/next/dist/client/link.js");
